<template>
  <div>
    <div class="d-flex justify-space-between my-2" style="color: #279600; font-size: 16px;">
      <span>SỐ TIỀN ĐƯỢC CHUYỂN ĐỔI</span> <strong>{{
        paymentInfo && paymentInfo ?
            formatCurrency(parseInt(paymentInfo.oldProductPrice) - parseInt(paymentInfo.totalDeduct) + parseInt(paymentInfo.unusedReceiptAmount)) : 0 + ' (đ)' }} </strong>
    </div>
    <div class="payment-info">
      <div style=" font-size: 16px"><strong>Chi tiết</strong></div>
      <div class="d-flex justify-space-between my-2">
        <div style="width: 60%">Số tiền đã đóng cho sản phẩm gốc</div>
        <div style="font-weight: 600">{{ paymentInfo && paymentInfo.oldProductPrice ? formatCurrency(paymentInfo.oldProductPrice) : 0 + ' (đ)' }}</div>
      </div>
      <div class="d-flex justify-space-between my-2">
        <div>Khấu trừ chi phí đã học</div>
        <div style="font-weight: 600">{{ paymentInfo && paymentInfo.totalDeduct ? formatCurrency(paymentInfo.totalDeduct) : 0 + ' (đ)' }}</div>
      </div>
      <div class="d-flex justify-space-between my-2">
        <div>Số tiền cọc còn lại chưa quy đổi</div>
        <div style="font-weight: 600">{{ paymentInfo && paymentInfo.unusedReceiptAmount ? formatCurrency(paymentInfo.unusedReceiptAmount) : 0 + ' (đ)' }}</div>
      </div>
      <div class="text-center mb-2 mt-4" style="color: #ff0000;font-style: italic">
        *Lưu ý: Phần tiền được chuyển đổi này sẽ không được tính doanh thu
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    paymentInfo: {
      type: Object,
      default: () => ({

      }),
    }
  }
};
</script>

<style lang="scss" scoped>
.payment-info {
  background: #e5f4ff;
  border-radius: 8px;
  padding: 12px;
}
</style>